import React from 'react';
import { Link } from 'react-router-dom';

const MenuItems = (props) => {
    const { parentMenu, secondParentMenu, activeMenu } = props;

    return (
        <React.Fragment>
            <li className={parentMenu === 'Home'}>
                <Link to="/">Home</Link>
                {/* <ul className="sub-menu">
                    <li>
                        <Link to="/" className={activeMenu === "/home-1" ? "active-menu" : ""}>Home One</Link>
                    </li>
                    <li>
                        <Link to="/home-2" className={activeMenu === "/home-2" ? "active-menu" : ""}>Home Two</Link>
                    </li>
                    <li>
                        <Link to="/home-3" className={activeMenu === "/home-3" ? "active-menu" : ""}>Home Three</Link>
                    </li>
                    <li>
                        <Link to="/home-4" className={activeMenu === "/home-4" ? "active-menu" : ""}>Home Four</Link>
                    </li>

                    <li className={secondParentMenu === 'Home' ? 'dropdown current-menu-item' : 'dropdown'}>
                        <Link to="#">Header Style</Link>
                        <ul className="sub-menu right ">
                            <li>
                                <Link to="/" className={activeMenu === "/" ? "active-menu" : ""}>Header One</Link>
                            </li>
                            <li>
                                <Link to="/home-2" className={activeMenu === "/home-2" ? "active-menu" : ""}>Header Two</Link>
                            </li>
                            <li>
                                <Link to="/home-3" className={activeMenu === "/home-3" ? "active-menu" : ""}>Header Three</Link>
                            </li>
                            <li>
                                <Link to="/home-4" className={activeMenu === "/home-4" ? "active-menu" : ""}>Header Four</Link>
                            </li>
                        </ul>
                    </li>
                </ul>*/}
            </li>
            <li className={parentMenu === 'about'/*  ? 'dropdown current-menu-item' : 'dropdown' */}>
                <Link to="/about" className={activeMenu === "/about" ? "active-menu" : ""}>About Us</Link>
                {/* <ul className="sub-menu">
                    <li>
                        <Link to="/about" className={activeMenu === "/about" ? "active-menu" : ""}>About Us</Link>
                    </li>
                    <li>
                        <Link to="/team" className={activeMenu === "/team" ? "active-menu" : ""}>Life at Ramana</Link>
                    </li>
                    <li>
                        <Link to="/team-details" className={activeMenu === "/team-details" ? "active-menu" : ""}>About Our CEO</Link>
                    </li>

                </ul> */}
            </li>
            {/* <li className={parentMenu === 'page' ? 'dropdown current-menu-item' : 'dropdown'}>
                <Link to="#">Pages</Link>
                <ul className="sub-menu">
                    <li>
                        <Link to="/team" className={activeMenu === "/team" ? "active-menu" : ""}>Team</Link>
                    </li>
                    <li>
                        <Link to="/team-details" className={activeMenu === "/team-details" ? "active-menu" : ""}>Team Details</Link>
                    </li>
                    <li>
                        <Link to="/testimonials" className={activeMenu === "/testimonials" ? "active-menu" : ""}>Testimonials</Link>
                    </li>
                    <li>
                        <Link to="/faq" className={activeMenu === "/faq" ? "active-menu" : ""}>Faq</Link>
                    </li>
                    <li>
                        <Link to="/error" className={activeMenu === "/error" ? "active-menu" : ""}>404 Error</Link>
                    </li>
                </ul>
            </li> */}
            <li className={parentMenu === 'Our Products' ? 'dropdown current-menu-item' : 'dropdown'}>
                <Link to="#">Our Products</Link>
                <ul className="sub-menu">
                    <li>
                        <Link to="/products" className={activeMenu === "/products" ? "active-menu" : ""}>All Products</Link>
                    </li>
                    <li>
                        <Link to="/horizontal-automatic-container-shear" className={activeMenu === "/horizontal-automatic-container-shear" ? "active-menu" : ""}>Horizontal Automatic Container Shearing Machine</Link>
                    </li>
                    {/* <li>
                        <Link to="/movable-excavator" className={activeMenu === "/movable-excavator" ? "active-menu" : ""}>Movable Excavator</Link>
                    </li> */}

                    <li>
                        <Link to="/vertical-scrap-shear" className={activeMenu === "/vertical-scrap-shear" ? "active-menu" : ""}>Vertical Heavy Duty Scrap Shearing Machine</Link>
                    </li>
                    <li>
                        <Link to="/hydraulic-scrap-baler" className={activeMenu === "/hydraulic-scrap-baler" ? "active-menu" : ""}>Hydraulic Scrap Baler</Link>
                    </li>

                    <li>
                        <Link to="/double-shaft-shredder" className={activeMenu === "/double-shaft-shredder" ? "active-menu" : ""}>Double Shaft Scrap Shredder</Link>
                    </li>
                    {/* <li>
                        <Link to="/fixed-boom-excavator" className={activeMenu === "/fixed-boom-excavator" ? "active-menu" : ""}>FIXED BOOM EXCAVATOR</Link>
                    </li> */}
                    <li>
                        <Link to="/scrap-magnet" className={activeMenu === "/scrap-magnet" ? "active-menu" : ""}>Scrap Magnet</Link>
                    </li>
                    <li>
                        <Link to="/grabber" className={activeMenu === "/grabber" ? "active-menu" : ""}>SCRAP GRABBER</Link>
                    </li>
                </ul>
            </li>
            {/* <li className={parentMenu === 'Project' ? 'dropdown current-menu-item' : 'dropdown'}>
                <Link to="#">Projects</Link>
                <ul className="sub-menu">
                    <li>
                        <Link to="/project" className={activeMenu === "/project" ? "active-menu" : ""}>Project</Link>
                    </li>
                    <li>
                        <Link to="/project-details" className={activeMenu === "/project-details" ? "active-menu" : ""}>Project Details</Link>
                    </li>
                </ul>
            </li> */}
            {/* <li className={parentMenu === 'blog' ? 'dropdown current-menu-item' : 'dropdown'}>
                <Link to="#">Blog</Link>
                <ul className="sub-menu">
                    <li>
                        <Link to="/blog" className={activeMenu === "/blog" ? "active-menu" : ""}>Blog</Link>
                    </li>
                    <li>
                        <Link to="/blog-list" className={activeMenu === "/blog-list" ? "active-menu" : ""}>Blog List</Link>
                    </li>

                    <li>
                        <Link to="/blog-details" className={activeMenu === "/blog-details" ? "active-menu" : ""}>Blog details</Link>
                    </li>
                </ul>
            </li> */}
            <li className={parentMenu === 'contact' ? 'current-menu-item' : ''}>
                <Link to="/contact" className={activeMenu === "/contact" ? "active-menu" : ""}>Contact</Link>
            </li>

        </React.Fragment>
    );
}

export default MenuItems;